import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	minutes: {
		id: 'app.guideDuration.minutes',
		defaultMessage: '{value} min',
		description:
			'A session\'s length in whole minutes, shown under its title in a program\'s session list, e.g. "10 min"',
	},
	seconds: {
		id: 'app.guideDuration.seconds',
		defaultMessage: '{value} sec',
		description:
			'A session\'s length in seconds, shown under its title when the session runs under a minute, e.g. "53 sec"',
	},
});
